// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gateway-grid {
  width: 100%;
  display: block;
  flex: 1;
}
.gateway-grid.ag-theme-alpine {
  height: 100%;
  min-height: 300px;
}
.gateway-grid.ag-theme-alpine .ag-root-wrapper {
  width: 100%;
  height: 100%;
}
.gateway-grid.ag-theme-alpine .ag-root {
  width: 100%;
  height: 100%;
}

.text-center {
  padding: 2rem;
}

:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  /* When maxHeight is set to a specific value (not percentage), use that height */
}
:host[data-max-height-type=fixed] {
  flex: none;
  /* Height will be set via style attribute from component */
}

::ng-deep ag-grid-angular {
  width: 100% !important;
  display: block;
  flex: 1;
}

::ng-deep .ag-root-wrapper {
  width: 100% !important;
}

::ng-deep .ag-theme-quartz,
::ng-deep .ag-theme-alpine {
  width: 100% !important;
}

::ng-deep .readonly-cell {
  background-color: #f8f9fa !important;
  cursor: default !important;
}

::ng-deep .readonly-cell:hover {
  background-color: #f8f9fa !important;
}

::ng-deep .copy-btn {
  opacity: 0.6;
  transition: opacity 0.2s ease;
  border: none !important;
  background: transparent !important;
  color: #6c757d !important;
  min-width: auto !important;
  width: 22px !important;
  height: 22px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 3px !important;
}

::ng-deep .copy-btn:hover {
  opacity: 1;
  background-color: #f8f9fa !important;
  color: #495057 !important;
}

::ng-deep .copy-btn:active {
  background-color: #e9ecef !important;
  transform: translateY(1px);
}

::ng-deep .copy-btn i {
  font-size: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/gateway-table/gateway-table.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;EACA,OAAA;AACF;AACE;EACE,YAAA;EACA,iBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AAEI;EACE,WAAA;EACA,YAAA;AAAN;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EAEA,gFAAA;AAHF;AAIE;EACE,UAAA;EACA,0DAAA;AAFJ;;AAMA;EACE,sBAAA;EACA,cAAA;EACA,OAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;;EAEE,sBAAA;AAHF;;AAMA;EACE,oCAAA;EACA,0BAAA;AAHF;;AAMA;EACE,oCAAA;AAHF;;AAMA;EACE,YAAA;EACA,6BAAA;EACA,uBAAA;EACA,kCAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;AAHF;;AAMA;EACE,UAAA;EACA,oCAAA;EACA,yBAAA;AAHF;;AAMA;EACE,oCAAA;EACA,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF","sourcesContent":[".gateway-grid {\n  width: 100%;\n  display: block;\n  flex: 1;\n\n  &.ag-theme-alpine {\n    height: 100%;\n    min-height: 300px;\n\n    .ag-root-wrapper {\n      width: 100%;\n      height: 100%;\n    }\n\n    .ag-root {\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n\n.text-center {\n  padding: 2rem;\n}\n\n:host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n\n  /* When maxHeight is set to a specific value (not percentage), use that height */\n  &[data-max-height-type='fixed'] {\n    flex: none;\n    /* Height will be set via style attribute from component */\n  }\n}\n\n::ng-deep ag-grid-angular {\n  width: 100% !important;\n  display: block;\n  flex: 1;\n}\n\n::ng-deep .ag-root-wrapper {\n  width: 100% !important;\n}\n\n::ng-deep .ag-theme-quartz,\n::ng-deep .ag-theme-alpine {\n  width: 100% !important;\n}\n\n::ng-deep .readonly-cell {\n  background-color: #f8f9fa !important;\n  cursor: default !important;\n}\n\n::ng-deep .readonly-cell:hover {\n  background-color: #f8f9fa !important;\n}\n\n::ng-deep .copy-btn {\n  opacity: 0.6;\n  transition: opacity 0.2s ease;\n  border: none !important;\n  background: transparent !important;\n  color: #6c757d !important;\n  min-width: auto !important;\n  width: 22px !important;\n  height: 22px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 3px !important;\n}\n\n::ng-deep .copy-btn:hover {\n  opacity: 1;\n  background-color: #f8f9fa !important;\n  color: #495057 !important;\n}\n\n::ng-deep .copy-btn:active {\n  background-color: #e9ecef !important;\n  transform: translateY(1px);\n}\n\n::ng-deep .copy-btn i {\n  font-size: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
